import React from 'react';
import './ToS.css';
import { useTranslation } from '../i18n';

const ToS = () => {
  const { t } = useTranslation();
  return (
    <div className="long-text-wrapper">
      <h3>Bookie - {t.termsofservice}</h3>
      <h4>{t.effectiveDate}: 27 Nov, 2024</h4>
      <div className="pt-65">{t.tos.intro}</div>

      <h4>1. {t.tos.acceptance}</h4>
      <div className="pt-65">{t.tos.acceptanceMessage}</div>

      <h4>2. {t.tos.userdata}</h4>
      <div className="pt-65">{t.tos.userdataMessage}</div>

      <h4>3. {t.tos.storage}</h4>
      <div className="pt-65">{t.tos.storageMessage}</div>

      <h4>4. {t.tos.security}</h4>
      <div className="pt-65">{t.tos.securityMessage}</div>

      <h4>5. {t.tos.service}</h4>
      <div className="pt-65">{t.tos.serviceMessage}</div>

      <h4>6. {t.tos.changes}</h4>
      <div className="pt-65">{t.tos.changesMessage}</div>
    </div>
  );
};

export default ToS;
